import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Controller, useForm } from 'react-hook-form'
import { modalStyles } from '../../TagDetails/TagOptionModal'
import { useModifyContentSchema } from '../../../../../../api/things'
import SydModal from '../../../../../commonDesign/SydModal'
import SydLabel from '../../../../../commonDesign/SydLabel'
import SydInput from '../../../../../commonDesign/SydInput'
import ErrorDisplay from '../../../../../molecules/ErrorDisplay'
import SaveCancelButtons from '../../../../../molecules/SaveCancelButtons'

const ThingSchemaModal = ({ open, onClose, thingSchema }) => {
  const classes = modalStyles()
  const { mutateAsync: modifyThingSchema, isLoading, isError, error } = useModifyContentSchema()

  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      name: thingSchema?.name || '',
      description: thingSchema?.description || '',
      code: thingSchema?.code || '',
      category: thingSchema?.category || ''
    }
  })
  useEffect(() => {
    if (thingSchema) {
      form.reset({
        name: thingSchema?.name || '',
        code: thingSchema?.code || '',
        description: thingSchema?.description || '',
        category: thingSchema?.category || ''
      })
    }
  }, [thingSchema, form])
  const onSubmit = useCallback(async (data) => {
    const command = {
      levelTypeId: thingSchema?.levelTypeId,
      thingConfigurationId: thingSchema?.thingConfigurationId,
      ...data
    }
    const result = await modifyThingSchema(command)
    if (result && result.success) {
      onClose()
    }
  }, [thingSchema?.levelTypeId, thingSchema?.thingConfigurationId, modifyThingSchema, onClose])
  return (
    <SydModal open={open} onClose={onClose} title='Content Configuration'>
      <div className={classes.inputRow}>
        <Controller
          name='name'
          control={form.control}
          rules={{ required: 'Name is required' }}
          render={({ field, fieldState }) => (
            <SydLabel label='Name'>
              <SydInput {...field} error={fieldState.error} />
            </SydLabel>
          )}
        />
        <Controller
          name='description'
          control={form.control}
          render={({ field, fieldState }) => (
            <SydLabel label='Description'>
              <SydInput {...field} error={fieldState.error} />
            </SydLabel>
          )}
        />
      </div>
      <br />
      <div className={classes.inputRow}>
        <Controller
          name='code'
          control={form.control}
          render={({ field, fieldState }) => (
            <SydLabel label='Code'>
              <SydInput {...field} error={fieldState.error} disabled />
            </SydLabel>
          )}
        />
        <Controller
          name='category'
          control={form.control}
          rules={{ required: 'Category is required' }}
          render={({ field, fieldState }) => (
            <SydLabel label='Category'>
              <SydInput {...field} error={fieldState.error} />
            </SydLabel>
          )}
        />
      </div>
      {isError && (
        <div className={classes.inputRow}>
          <ErrorDisplay error={error} />
        </div>
      )}
      <div className={classes.buttonRow}>
        <SaveCancelButtons
          containerClassName={classes.saveCancel}
          onSave={form.handleSubmit(onSubmit)}
          onCancel={onClose}
          isSubmitting={isLoading}
        />
      </div>
    </SydModal>
  )
}

ThingSchemaModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  thingSchema: PropTypes.object
}

export default ThingSchemaModal
